import { Component, Input, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { keysToTranslate } from '@core/util/keys-to-translate';
import { TranslateDirective } from '@ngx-translate/core';
import { DisableDirective } from '../form/disabled.rective';
import { FormColumnsDirective } from '../form/form-columns.directive';
import { FormRowDirective } from '../form/form-row.directive';
import { FormControlComponent } from '../form/form-control.component';
import { AutofocusDirective } from '../autofocus/autofocus.directive';
import { MkdeDatepickerComponent } from '../datepicker/mkde-datepicker.component';

@Component({
  selector: 'app-defect-dialog',
  templateUrl: './defect-dialog.component.html',
  imports: [
    TranslateDirective,
    DisableDirective,
    FormsModule,
    FormColumnsDirective,
    ReactiveFormsModule,
    FormRowDirective,
    FormControlComponent,
    AutofocusDirective,
    MkdeDatepickerComponent,
  ],
})
export class DefectDialogComponent implements OnInit {
  protected modal = inject(NgbActiveModal);

  @Input()
  public defectForm!: FormGroup;

  @Input()
  public readonly: boolean = true;

  @Output()
  public defectChange: EventEmitter<any> = new EventEmitter();

  public constructor() {
    keysToTranslate([
      'Mangel.Schweregrad',
      'Mangel.RueckmeldungBis',
      'Mangel.Umfang',
      'Mangel.Wiederholung',
      'Mangel.Beschreibung',
    ]);
  }

  public get showDefectSeveritySelection() {
    return this.defectForm.value.showDefectSeveritySelection;
  }

  public get defectResult() {
    return this.defectForm.get('result') as FormGroup;
  }

  public ngOnInit(): void {
    if (!this.defectResult.value.defectRepetition) {
      this.defectResult.patchValue({ defectRepetition: 0 });
    }
  }

  public onDefectChange(): void {
    if (this.defectForm.valid) {
      this.defectChange.emit();
    }
  }
}
